import { Link } from "@inertiajs/react"
import { LayoutGrid } from "lucide-react"
import type { PropsWithChildren } from "react"

import { AppShell } from "@/components/app-shell"
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu"
import { cn } from "@/lib/utils"
import { settingsProfilePath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

export default function AppHeaderLayout({
  children,
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[]
}>) {
  return (
    <AppShell>
      <main className="relative mx-auto flex h-full w-full max-w-4xl flex-1 flex-col gap-4 rounded-xl py-8">
        <div className="absolute top-2 left-2 flex items-center space-x-6">
          <NavigationMenu className="flex h-full items-stretch">
            <NavigationMenuList className="flex h-full items-stretch space-x-2">
              <NavigationMenuItem className="relative flex h-full items-center">
                <Link
                  href={settingsProfilePath()}
                  className={cn(
                    navigationMenuTriggerStyle(),
                    "h-9 cursor-pointer px-3",
                  )}
                >
                  <LayoutGrid className="h-4 w-4" />
                </Link>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        {children}
      </main>
    </AppShell>
  )
}
